module.exports = __webpack_public_path__ + "static/media/twitter.7f6f3f2a.png";